
export const urlFormatValidation = {
    name: "url-format",
    validate: (value) => value == null || !value || validateUrlFormat(value),
};

export const validateUrlFormat = (value) => (
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=%]+$/.test(value)
);

